export const MAX_ZOOM = 5;
export const MIN_ZOOM = 0.1;
export const SCROLL_SENSITIVITY = 0.0005;
export const MAX_VELOCITY = 0;
export const BOUNDARY = (): {x: [number, number], y: [number, number]} => {
  return {
    // x: [-window.innerWidth * (1 / MIN_ZOOM), window.innerWidth * (1 / MIN_ZOOM)],
    // y: [-window.innerHeight * (1 / MIN_ZOOM), window.innerHeight * (1 / MIN_ZOOM)],
    x: [-window.innerWidth * (1), window.innerWidth * (1)],
    y: [-window.innerHeight * (1), window.innerHeight * (1)],
  }
}
